import { render, staticRenderFns } from "./EditorOption.vue?vue&type=template&id=dc981e9c&"
import script from "./EditorOption.vue?vue&type=script&lang=ts&"
export * from "./EditorOption.vue?vue&type=script&lang=ts&"
import style0 from "./EditorOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports